/**
 * @description 导入所有 pinia 模块，请勿修改。
 */
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
export function setupStore(app) {
    app.use(pinia);
}
export default pinia;
